import { array, literal, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ClientId } from '../../client/Id';
import { Id as JobTypeId } from '../../job/job-type';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';
import { DifficultyWithUnknown } from '../DifficultyWithUnknown';
import { UserId } from '../UserId';

export const ReviewSeverity = literal('major', 'minor', 'note', 'estimator');

export const FilterRequest = struct({
	client: array(ClientId),
	jobType: array(JobTypeId),
	requirements: array(array(RequirementId)),
	difficulty: array(DifficultyWithUnknown),
	completedAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
	assignee: array(UserId),
	severity: array(ReviewSeverity),
});
